import type { PromoteFormState } from './types';

export const mutations = {
	setAmount: (state: PromoteFormState, amount: number): PromoteFormState => ({
		...state,
		amount,
	}),

	setFirstName: (state: PromoteFormState, firstName: string): PromoteFormState => ({
		...state,
		firstName,
		name: `${firstName} ${state.lastName}`,
	}),
	setLastName: (state: PromoteFormState, lastName: string): PromoteFormState => ({
		...state,
		lastName,
		name: `${state.firstName} ${lastName}`,
	}),
	setName: (state: PromoteFormState, name: string): PromoteFormState => ({
		...state,
		name,
	}),
	setCustomAmountSelected: (state: PromoteFormState, customAmountSelected: boolean): PromoteFormState => ({
		...state,
		customAmountSelected,
	}),
	setPublic: (state: PromoteFormState, isPublic: boolean): PromoteFormState => ({
		...state,
		isPublic,
	}),
	setShouldSavePaymentMethod: (state: PromoteFormState, shouldSavePaymentMethod: boolean): PromoteFormState => ({
		...state,
		paymentMethodSaveOptions: {
			...state.paymentMethodSaveOptions,
			shouldSavePaymentMethod,
		},
	}),
	setValidationErrors: (
		state: PromoteFormState,
		validationErrors: PromoteFormState['validationErrors'],
	): PromoteFormState => ({
		...state,
		validationErrors,
	}),
	setGeneralErrorMessage: (state: PromoteFormState, generalErrorMessage: string): PromoteFormState => ({
		...state,
		...{ formState: { status: 'error', error: generalErrorMessage } },
	}),
	clearGeneralErrorMessage: (state: PromoteFormState): PromoteFormState => ({
		...state,
		...{ formState: { status: 'ready' } },
	}),
	setLoading: (state: PromoteFormState): PromoteFormState => ({
		...state,
		...{ formState: { status: 'loading' } },
	}),
	clearLoading: (state: PromoteFormState): PromoteFormState => ({
		...state,
		...{ formState: { status: 'ready' } },
	}),
	setMoreWaysExpanded: (state: PromoteFormState, moreWaysExpanded: boolean): PromoteFormState => ({
		...state,
		moreWaysExpanded,
	}),
	setPromoteFormRevealed: (state: PromoteFormState, promoteFormRevealed: boolean): PromoteFormState => ({
		...state,
		promoteFormRevealed,
	}),
};
